import i18next, { TOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { brands, brandsList } from './ptBR';

export function i18nInit() {
  i18next.use(initReactI18next).init({
    resources: {
      ptBR: brands,
    },
    ns: brandsList,
    defaultNS: 'common',
    fallbackNS: 'common',
    fallbackLng: 'ptBR',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });
}

export class I18n {
  private static marca = String(brands.common);

  static getMarca(): string {
    return I18n.marca;
  }

  static setMarca(marca: string) {
    I18n.marca = marca;
    i18next.setDefaultNamespace(marca);
  }
}

export function t(message: string, options?: TOptions): string {
  return i18next.t(message, { ns: I18n.getMarca(), ...options });
}

export function tBetween(messages: string[], options?: TOptions): string | null {
  const key = messages.find((message) => i18next.exists(message, { ns: I18n.getMarca() }));

  return key ? t(key, options) : null;
}

export function exists(message: string): boolean {
  return i18next.exists(message, { ns: I18n.getMarca() });
}

export default new I18n();
